import { render, staticRenderFns } from "./asambleaListList.vue?vue&type=template&id=06f220fe"
import script from "./asambleaListList.vue?vue&type=script&lang=js"
export * from "./asambleaListList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports